//Copyright Open Trade Technology Ltd. 2023. All rights reserved.
export const LoanCTOProperties = [
  'id',
  'loanAddr',
  'borrowerAddr',
  'fundingVaultAddr',
  'poolAddr',
  'state',
  'transitionState',
  'durationDays',
  'principal',
  'startingPrincipal',
  'interest',
  'indicativeInterest',
  'originationFee',
  'indicativeApr',
  'finalizedApr',
  'exchangeRateAtDeposit',
  'exchangeRateAtMaturity',
  'fundingVaultBalance',
  'assetsRolloverToNextLoan',
  'assetsToReturnToPool',
  'accrualStartDayTimestamp',
  'accrualStartTimestamp',
  'transferInWindowDurationDays',
  'transferOutWindowDurationDays',
  'depositClosingTimestamp',
  'redemptionRequestClosingTimestamp',
  'maturingTimestamp',
  'redemptionAvailableTimestamp',
  'canRequestRedemption',
  'totalSupply',
  'assetsFromPool',
  'assetToReturnToPool',
  'assetsFromPriorLoan',
]
export const PoolAccountCTOProperties = [
  'id',
  'blockNumber',
  'timestamp',
  'dayNumber',
  'timeOfDay',
  'poolType',
  'poolAddr',
  'liquidityAssetAddr',
  'accountAddr',
  'tokenBalance',
  'interestRate',
  'principalEarningInterest',
  'earlyWithdrawInterestAdjustment',
  'maxWithdrawRequest',
  'maxRedeemRequest',
  'maxRequestCancellation',
  'maxWithdraw',
  'maxRedeem',
  'requestedSharesOf',
  'redeemableSharesOf',
  'requestedAssetsOf',
  'requestedPrincipalOf',
  'withdrawableAssetsOf',
  'earlyRequestedSharesOf',
  'earlyRequestedAssetsOf',
  'earlyRequestedPrincipalOf',
  'earlyAcceptedSharesOf',
  'earlyAcceptedAssetsOf',
  'earlyAcceptedPrincipalOf',
  'assetsTransferringIn',
  'assetsTransferringOut',
  'principalTransferringOut',
  'interestAccruedInActiveLoan',
  'expectedInterestAtMaturity',
  'totalAssetsDeposited',
  'totalAssetsWithdrawn',
  'totalAssetsAtMaturity',
  'totalAssetCurrent',
  'interestInDay',
]
export const PoolFlexAccountCTOProperties = [
  'id',
  'blockNumber',
  'timestamp',
  'dayNumber',
  'timeOfDay',
  'poolType',
  'poolAddr',
  'liquidityAssetAddr',
  'accountAddr',
  'tokenBalance',
  'interestRate',
  'principalEarningInterest',
  'dailyInterestRate',
  'maxWithdrawRequest',
  'maxRedeemRequest',
  'requestedSharesOf',
  'requestedAssetsOf',
  'interestAccrued',
  'assetsDeposited',
  'assetsWithdrawn',
  'sharesTransitioningIn',
  'assetsTransitioningIn',
  'assetsDueForWithdraws',
  'accountOutstandingLoanPrincipals',
  'interestInDay',
]
export const PoolFlexOverviewCTOProperties = [
  'businessDayRegistryAddr',
  'closeOfDepositTime',
  'closeOfWithdrawTime',
  'transferInDays',
  'transferOutDays',
  'nonBusinessDays',
  'feeVaultAddr',
  'withdrawControllerAddr',
  'borrowerVaultAddr',
  'maxCapacity',
  'id',
  'poolType',
  'poolAddr',
  'liquidityAssetAddr',
  'poolControllerAddr',
  'name',
  'symbol',
  'borrowerManagerAddr',
  'poolAdminAddr',
  'borrowerWalletAddr',
  'chainConfigurationName',
  'creationBlock',
  'blockNumber',
  'timestamp',
  'dayNumber',
  'timeOfDay',
  'chainId',
  'totalOutstandingLoanPrincipal',
  'interestRate',
  'dailyInterestRate',
  'state',
  'totalPrincipalEarningInterest',
  'totalInterestAccrued',
  'totalAssetsDeposited',
  'totalAssetsWithdrawn',
  'exchangeRate',
  'totalSupply',
  'totalRequestedShares',
  'totalRequestedAssets',
  'totalSharesTransitioningIn',
  'totalAssetsTransitioningIn',
  'totalAssetsDueForWithdraws',
  'lastDayAccrued',
]
export const PoolDynamicAccountCTOProperties = [
  'id',
  'blockNumber',
  'timestamp',
  'dayNumber',
  'timeOfDay',
  'poolType',
  'poolAddr',
  'liquidityAssetAddr',
  'accountAddr',
  'tokenBalance',
  'interestRate',
  'principalEarningInterest',
  'maxWithdrawRequest',
  'maxRedeemRequest',
  'requestedSharesOf',
  'requestedAssetsOf',
  'acceptedShares',
  'acceptedAssets',
  'assetsDeposited',
  'assetsWithdrawn',
  'gainLoss',
  'gainLossInDay',
  'debits',
  'debitsInDay',
  'credits',
  'creditsInDay',
  'fees',
  'feesInDay',
]
export const PoolDynamicOverviewCTOProperties = [
  'feeCollectorAddress',
  'closeOfDepositTime',
  'closeOfWithdrawTime',
  'transferOutDays',
  'id',
  'poolType',
  'poolAddr',
  'liquidityAssetAddr',
  'poolControllerAddr',
  'name',
  'symbol',
  'borrowerManagerAddr',
  'poolAdminAddr',
  'borrowerWalletAddr',
  'chainConfigurationName',
  'creationBlock',
  'blockNumber',
  'timestamp',
  'dayNumber',
  'timeOfDay',
  'chainId',
  'totalOutstandingLoanPrincipal',
  'state',
  'totalAssetsDeposited',
  'totalAssetsWithdrawn',
  'exchangeRate',
  'exchangeRateAtSetDay',
  'exchangeRateChangeRate',
  'exchangeRateCompoundingRate',
  'exchangeRateAtMaturity',
  'exchangeRateMaturityDay',
  'exchangeRateType',
  'totalInterestAccrued',
  'totalShares',
  'totalAssets',
  'interestRate',
  'indicativeInterestRate',
  'collateralRate',
]
export const PoolOverviewCTOProperties = [
  'id',
  'poolType',
  'poolAddr',
  'liquidityAssetAddr',
  'poolControllerAddr',
  'name',
  'symbol',
  'borrowerManagerAddr',
  'poolAdminAddr',
  'borrowerWalletAddr',
  'chainConfigurationName',
  'creationBlock',
  'closeOfBusinessTime',
  'earlyWithdrawFeeBps',
  'feeVaultAddr',
  'withdrawControllerAddr',
  'borrowerVaultAddr',
  'maxCapacity',
  'blockNumber',
  'timestamp',
  'dayNumber',
  'timeOfDay',
  'chainId',
  'totalOutstandingLoanPrincipal',
  'settledLoans',
  'state',
  'rolloverState',
  'rolloverActor',
  'rolloverTimeToActionWindow',
  'rolloverTimeLeftInActionWindow',
  'rolloverTimePastActionWindow',
  'totalAvailableAssets',
  'totalAvailableSupply',
  'currentExpectedInterest',
  'liquidityPoolAssets',
  'totalAssets',
  'totalAssetsDeposited',
  'totalAssetsWithdrawn',
  'totalRequestedShares',
  'totalRedeemableShares',
  'totalRequestedAssets',
  'totalWithdrawableAssets',
  'feeVaultBalance',
  'borrowerVaultBalance',
  'borrowerWalletBalance',
  'poolBalance',
  'exchangeRateAtMaturity',
  'requestedLoanState',
  'activeLoanState',
  'maturedLoanState',
  'createdLoanState',
  'rolloverInitiated',
  'redemptionLenders',
  'requestedShares',
  'redeemableShares',
  'totalEarlyRequestedShares',
  'totalEarlyRequestedAssets',
  'totalEarlyAcceptedShares',
  'totalEarlyAcceptedAssets',
  'rolloverClosingLoanState',
  'rolloverOpeningLoanState',
  'rolloverAssetsToReturnToPool',
  'rolloverOpeningLoanPrincipal',
  'rolloverClosingLoanEndingValue',
  'rolloverAssetToGetFromPool',
  'rolloverNetRepaymentWithFees',
  'rolloverMaturingLoanFees',
  'rolloverAssetsFromPriorLoan',
  'rolloverType',
  'totalEarlyWithdrawPrincipal',
  'poolAssetsForWithdraw',
]
export const PoolBaseConfigurationCTOProperties = [
  'id',
  'poolType',
  'poolAddr',
  'liquidityAssetAddr',
  'poolControllerAddr',
  'name',
  'symbol',
  'borrowerManagerAddr',
  'poolAdminAddr',
  'borrowerWalletAddr',
  'chainConfigurationName',
  'creationBlock',
]
export const PoolEventCTOProperties = [
  'id',
  'poolAddr',
  'poolName',
  'poolAddrAccountAddr',
  'eventType',
  'eventName',
  'currency',
  'symbol',
  'accountAddr',
  'withdrawSequenceId',
  'withdrawStage',
  'loanAddr',
  'receiverAddr',
  'senderAddr',
  'priorLoanAddr',
  'blockNumber',
  'transactionHash',
  'timestamp',
  'transferOutDayTimestamp',
  'transferInDayTimestamp',
  'chainId',
  'assets',
  'liquidityTokenSymbol',
  'shares',
  'assetsFromPool',
  'assetsFromPriorToNextLoan',
  'assetToReturnToPool',
  'fees',
  'principal',
  'repayment',
  'liquidityAssetAddr',
  'poolLiquidityAssetBalance',
  'borrowerVaultLiquidityAssetBalance',
  'borrowerWalletLiquidityAssetBalance',
  'feeVaultLiquidityAssetBalance',
  'poolAdminLiquidityAssetBalance',
  'accountLiquidityAssetBalance',
  'accountTokenBalance',
  'interestAccrued',
  'emailStatus',
  'depositType',
  'transferTxHash',
]
export const PoolTermAccountSummaryCTOProperties = [
  'startBlockNumber',
  'startTimestamp',
  'startDayNumber',
  'endDayNumber',
  'endBlockNumber',
  'endTimestamp',
  'averageTokenBalance',
  'sumInterestInADay',
  'averagePrincipalEarningInterest',
]
export const PoolFlexAccountSummaryCTOProperties = [
  'startBlockNumber',
  'startTimestamp',
  'startDayNumber',
  'endDayNumber',
  'endBlockNumber',
  'endTimestamp',
  'averageTokenBalance',
  'sumInterestInADay',
  'averagePrincipalEarningInterest',
]
export const PoolDynamicAccountSummaryCTOProperties = [
  'startBlockNumber',
  'startTimestamp',
  'startDayNumber',
  'endDayNumber',
  'endBlockNumber',
  'endTimestamp',
  'averageTokenBalance',
  'sumInterestInADay',
  'averagePrincipalEarningInterest',
]
export const WithdrawalActivityCTOProperties = [
  'requestedShares',
  'requestedAssets',
  'requestedPrincipal',
  'requestedRepayment',
  'requestTimestamp',
  'processedTimestamp',
  'repaidTimestamp',
  'lender',
  'loanAddr',
  'status',
  'eventId',
  'transactionHash',
]
